<template>
  <div>
    <p>正在跳轉到外部系統...</p>
  </div>
</template>

<script>
export default {
  name: 'ExternalPage',

  data () {
    return {
      externalUrl: 'https://qamp.pqmdatacenter.apps.rog-gaming.net/' // 替換成你的外部網址
    }
  },

  mounted () {
    this.$store.dispatch('getAuthorize', '/pqm/cfrAnalysisMgmt/pqmexternallinks')
      .then(response => {
        console.info(response)
        if (response.status === 'success' && response.data.accessible) {
          // 一進入頁面就打開新 tab
          window.open(this.externalUrl, '_blank')

          // 如果你希望當前頁面自動跳回首頁，也可以加：
          this.$router.replace('/') // 或其他頁面
          // this.$http.post('/api/lcd/analyzeMgmt/calibrationMode', this.propData).then(res => res.data)
          //   .then(res => {
          //     if (res.status === 'success') {
          //       this.calibrationModeMenu = res.data
          //     }
          //   })
        } else if (response.errCode === 'E10000002') {
          const routeData = this.$router.resolve({ path: '/noEnter/E10000002' })
          localStorage.setItem('errormsg', response.errMsg)
          window.location.assign(routeData.href)
        } else {
          const routeData = this.$router.resolve({ path: JSON.parse(localStorage.getItem('user')).home })
          window.location.assign(routeData.href)
        }
      })
      .catch(err => {
        console.log(err)
        const routeData = this.$router.resolve({ path: JSON.parse(localStorage.getItem('user')).home })
        window.location.assign(routeData.href)
      })
  }
}
</script>
